export enum SectionsType {
  Relationships = 'relationships',
  SubmissionForm = 'submission-form',
  Upload = 'upload',
  License = 'license',
  CcLicense = 'cclicense',
  AccessesCondition = 'accessCondition',
  OpfPolicies = 'opfPolicy',
  Identifiers = 'identifiers',
  Collection = 'collection',
  CoarNotify = 'coarnotify',
  Duplicates = 'duplicates'
}
